import { cn } from 'cn';
import { Spinner } from '../../Spinner/Spinner';

interface ButtonSpinnerProps {
  compact?: boolean | null;
  isLaane: boolean;
}

export function ButtonSpinner({ compact, isLaane }: ButtonSpinnerProps) {
  return (
    <Spinner
      className={cn(
        'flex items-center justify-center',
        compact ? 'laane:px-4' : 'laane:px-1',
      )}
      size={compact && isLaane ? 'small' : 'medium'}
    />
  );
}
